import { privacyActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export default createReducer(
  {
    allowMarketing: false,
    allowPerformance: false,
    isNikePrivacyAllowed: false,
    isSet: false,
    level: 0,
  },
  {
    [privacyActions.set.type]: (state, { payload }) => payload,
    [privacyActions.setNikePrivacy.type]: (state, { payload }) => ({
      ...state,
      isNikePrivacyAllowed: payload.isNikePrivacyAllowed,
    }),
  },
);
